import PropTypes from "prop-types";
import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomSelect } from "../CustomControls/CustomSelect";
import { CustomSearchBox } from "../CustomControls/CustomSearchBox";

export const ClinicalTrialsFilters = (props) => {
  const { t } = useTranslation();
  const {
    selectedLaboratory,
    selectedStatus,
    selectedSpecialty,
    masterData,
    isLoading,
    onChangeFilter,
    startupsSpecialties = [],
  } = props;

  const handleFilterChange = (filterName, selectedValue) => {
    if (filterName) {
      onChangeFilter(filterName, selectedValue);
    }
  };

  return (
    <>
      {/* Filtro por Sponsor */}
      <Col md={2}>
        <CustomSelect
          value={selectedLaboratory}
          name="laboratoryId"
          placeholder={t("clinicalTrials.startup.sponsor")}
          onChange={onChangeFilter}
          isMulti={false}
          isClearable={true}
          loading={isLoading}
          options={masterData?.Laboratories || []}
        />
      </Col>
      {/* Filtro por Acrónimo (búsqueda por texto) */}
      <Col md={2}>
        <CustomSearchBox
          handleSearch={(value) => handleFilterChange("title", value)}
          placeholder={t("clinicalTrials.startup.acronym")}
        />
      </Col>
      {/* Filtro por Especialidad */}
      <Col md={2}>
        <CustomSelect
          value={selectedSpecialty}
          name="specialtyId"
          placeholder={t("clinicalTrials.startup.specialty")}
          onChange={onChangeFilter}
          isMulti={false}
          isClearable={true}
          loading={isLoading}
          options={startupsSpecialties}
        />
      </Col>
      {/* Filtro por Estado */}
      <Col md={2}>
        <CustomSelect
          value={selectedStatus}
          name="statusId"
          placeholder={t("clinicalTrials.startup.status")}
          onChange={onChangeFilter}
          isMulti={false}
          isClearable={true}
          loading={isLoading}
          options={masterData?.Status || []}
          getOptionLabel={(option) => t(`clinicalTrials.statuses.${option.code}`) || option.title}
        />
      </Col>
    </>
  );
};

ClinicalTrialsFilters.propTypes = {
  selectedLaboratory: PropTypes.object,
  selectedStatus: PropTypes.object,
  selectedSpecialty: PropTypes.object,
  masterData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  onChangeFilter: PropTypes.func.isRequired,
  startupsSpecialties: PropTypes.array,
};
